import moment from 'moment';
import { DATE_FORMAT_PICKER } from 'src/config';
import { ControlInput } from 'src/graphql/_generated';
import * as Yup from 'yup';

const validateDate = (date?: string | null) => {
  if (!date) return true;
  if (typeof date === 'string') return moment(date, DATE_FORMAT_PICKER).isValid();
  return false;
};

export const rmpValidationSchema = Yup.object({
  id: Yup.string().nullable(),
  name: Yup.string().nullable().required('Required').max(255, 'Max 255 characters'),
  strategy: Yup.string().nullable().max(255, 'Max 255 characters'),
  status: Yup.string().nullable(),
  description: Yup.string().nullable().max(2048, 'Max 2048 characters'),
  expectedActiveDate: Yup.string().nullable().test('expectedActiveDate', 'Invalid Date', validateDate),
  actualActiveDate: Yup.string().nullable().test('actualActiveDate', 'Invalid Date', validateDate),
  reviewDate: Yup.string().nullable().test('reviewDate', 'Invalid Date', validateDate),
  annualCost: Yup.number().nullable().min(0, 'Must be positive'),
  vendor: Yup.string().nullable().max(255, 'Max 255 characters'),
  shortname: Yup.string().nullable().max(100, 'Max 100 characters'),
  origin: Yup.string().nullable().max(255, 'Max 255 characters'),
  linkText: Yup.string().nullable().max(255, 'Max 255 characters'),
  linkUrl: Yup.string()
    .nullable()
    .test('url', 'Invalid URL', function (value) {
      if (!value || value.trim() === '') return true; // Allow empty/null values
      return Yup.string().url().isValidSync(value);
    }),
  existingMaturity: Yup.string().nullable(),
  targetMaturity: Yup.string().nullable(),
  frameworkControlIds: Yup.array().of(Yup.string()),
});

export const rmpInitialValues: ControlInput = {
  id: null,
  name: null,
  strategy: null,
  status: null,
  owner: null,
  description: null,
  expectedActiveDate: null,
  actualActiveDate: null,
  reviewDate: null,
  annualCost: null,
  vendor: null,
  shortname: null,
  origin: null,
  linkText: null,
  linkUrl: null,
  existingMaturity: null,
  targetMaturity: null,
  frameworkControlIds: [],
};
